import React, { PropsWithChildren, ReactNode } from 'react'
import { ComponentProps } from 'react'

import { bemJoin, classNames } from '@app/lib/bem'
import { MergeProps } from '@app/lib/types'
import './Chip.scss'

export type ChipProps = MergeProps<
  ComponentProps<'div'>,
  {
    color?: 'danger' | 'warning' | 'success' | 'info' | 'neutral' | 'white' | 'primary-gradient'
    size?: 'lg' | 'md' | 'sm' | 'xs'
    variant?: 'filled' | 'outlined'
    minWidth?: boolean
    icon?: ReactNode
  }
>

const b = bemJoin('chip')

export const Chip = ({
  color = 'neutral',
  size = 'md',
  variant = 'outlined',
  minWidth = true,
  icon,
  className,
  children,
  ...rest
}: PropsWithChildren<ChipProps>) => {
  return (
    <div
      {...rest}
      className={classNames(
        b({
          [color]: true,
          [size]: true,
          [variant]: true,
          'min-width': minWidth
        }),
        className
      )}
    >
      {icon && <div className={b('icon')}>{icon}</div>}
      {children}
    </div>
  )
}
